import { handleApiCall } from "../api";



export const createProduct = (payload: any) => handleApiCall("post", `products`, payload, { headers: { "Content-Type": "multipart/form-data", } })

export const updateProduct = (productId: number, payload: any) => handleApiCall("patch", `products/${productId}`, payload, { headers: { "Content-Type": "multipart/form-data", } })

export const getFieldAttributes = (categoryId: number) => handleApiCall("get", `field-attributes/${categoryId}`)

export const getProduct = () => handleApiCall("get", `products`);

export const getProductById = (productId: number) => handleApiCall("get", `products/${productId}`);

export const getStoreById = (selectStore: any) => handleApiCall("get", `stores/${selectStore}`);

export const getProductByStoreId = (store_id, page, limit) => handleApiCall("get", `products?page=${page}&limit=${limit}&store_id=${store_id}`);

export const getStore = () => handleApiCall("get", `stores?page=&limit=`);

export const updateAndCreateVariant = (productID: number, postPayload) => handleApiCall("post", `/products/${productID}/variants`, postPayload, { headers: { "Content-Type": "multipart/form-data" } })



/**
 * 
 * 
 */
export const createBulkUpload = (payload: any, isFandB: boolean) =>
  handleApiCall("post", isFandB ? "/products/bulk-upload/fandb" : "/products/bulk-upload", payload, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const getBulkExportFandB = (storeId: any) => 
    handleApiCall('get', `/products/${storeId}/export`, {
      responseType: 'arraybuffer'
    });

//delete poroduct image
export const deleteProductImage = (image_id) => handleApiCall('delete',`/products/${image_id}/delete-image`);

// addons list
export const getAddonProduct = (storeId: any) => handleApiCall("get", `products?page=1&limit=10&store_id=${storeId}&group=all&type=addon`);

export const addonsUpdation = (productId: any, payload: any) => handleApiCall("post", `products/${productId}/addons`, payload)

export const deleteAddon = (productId:any, addonId: any) => handleApiCall("delete", `/products/${productId}/addons/${addonId}`)

// Pre Defined PRoducts
export const createPreDefinedProducts = (storeId: any, payload: any) => handleApiCall("post", `/products/${storeId}/predefine-product-upload`, payload)

// F&B Products
export const listProduct = (payload: any) => handleApiCall("post", "products/menu/list", payload);

export const createProductItem = (payload: any) => handleApiCall("post", "products/menu", payload, { headers: { "Content-Type": "multipart/form-data" } });

export const categoryList = (store_id: any) => handleApiCall("get", `product-categories?store_id=${store_id}`);

export const updateMenuById = (productId: any, payload: any) => handleApiCall("patch", `products/menu/${productId}`, payload, { headers: { "Content-Type" : "multipart/form-data"}});

export const deleteMenuById = (productId: any) => handleApiCall("delete", `products/menu/${productId}`);

export const listAddons = (store_id: any, params: any = {}) => {
    const { page = 1, limit = 10 } = params;
    return handleApiCall("get", `products?store_id=${store_id}&page=${page}&limit=${limit}`);
}

export const deleteAddonGroups = (groupId: number) => handleApiCall("delete", `customization-categories/${groupId}`)

export const menuAddonsUpdation = (productId: any, payload: any) => handleApiCall("post", `products/${productId}/addons`, payload)

export const createAddonsGroups = (payload: any) => handleApiCall("post", "customization-categories", payload);

// F&B Category Sequence Update
export const updateCategorySequence = (payload: any) => handleApiCall("put", "product-categories/sequence", payload);

// F&B Menu Item Sequence Update
export const updateProductSequence = (payload: any) => handleApiCall("put", "products/menu/sequence", payload);